<div class="table-actions">
  <div class="table-actions-left">

    <!-- Search -->
    <mat-form-field class="search-field" appearance="fill">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="currentSearchValue" placeholder="First, Last, or Email" (input)="onSearch()" />
      <button *ngIf="currentSearchValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <i class="fa-duotone fa-circle-xmark"></i>
      </button>
    </mat-form-field>

    <!-- DCO Filter -->
    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Filter</mat-label>
      <mat-select [(ngModel)]="currentFilterSelection" (selectionChange)="onFilterChange()">
        <mat-option *ngIf="currentFilterSelection !== null" [value]="null">
          <i class="fa-solid fa-xmark" style="margin-right: 8px;"></i>(Clear Filter)
        </mat-option>
        <mat-optgroup label="Dental Care Organizations">
          <mat-option *ngFor="let dco of dcos" [value]="dco.id">
            <i class="fa-solid fa-tooth" style="margin-right: 8px;"></i>
            {{ dco.displayName || ('DCO #' + dco.id) }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <!-- Date range -->
    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start">
        <input matEndDate [(ngModel)]="endDate" placeholder="End">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker (closed)="resetToFirstPageAndLoad()"></mat-date-range-picker>
    </mat-form-field>

    <!-- Quick ranges -->
    <button mat-stroked-button (click)="setToday()">Today</button>
    <button mat-stroked-button (click)="setYesterday()">Yesterday</button>
    <button mat-stroked-button (click)="setLast7()">Last 7</button>
    <button mat-stroked-button (click)="setThisMonth()">This month</button>

    <!-- Toggle Active Only -->
    <mat-slide-toggle [(ngModel)]="activeOnly" (change)="toggleFilters()" class="toggle-filter">
      Active only
    </mat-slide-toggle>

    <!-- TZ toggle -->
    <button mat-stroked-button (click)="toggleTz()" matTooltip="Toggle Pacific vs UTC">
      <i class="fa-solid" [ngClass]="timezoneLocal ? 'fa-clock' : 'fa-globe'"></i>
      &nbsp;{{ timezoneLocal ? 'Pacific time' : 'UTC' }}
    </button>

  </div>

  <div class="table-actions-right">
    <mat-slide-toggle [checked]="groupByUser"
                      (change)="onGroupToggle($event.checked)">
      Group by user
    </mat-slide-toggle>
  </div>
</div>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div class="mat-elevation-z8">
  <!-- GROUPED TABLE -->
  <table *ngIf="groupByUser"
         mat-table
         [dataSource]="rows"
         class="mat-elevation-z1"
         multiTemplateDataRows>

    <!-- groupSummary column -->
    <ng-container matColumnDef="groupSummary">
      <th mat-header-cell *matHeaderCellDef>User</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.kind === 'group'">
          <div class="group-summary-row" (click)="toggleUser(row.userId)">
            <!-- Chevron -->
            <button mat-icon-button
                    class="expand-btn"
                    [class.is-expanded]="expandedUserIds.has(row.userId)"
                    [attr.aria-expanded]="expandedUserIds.has(row.userId)"
                    (click)="$event.stopPropagation(); toggleUser(row.userId)">
              <mat-icon [@chev]="expandedUserIds.has(row.userId) ? 'expanded' : 'collapsed'">chevron_right</mat-icon>
            </button>

            <!-- Avatar -->
            <div class="avatar">{{ initials(row.name || row.email) }}</div>

            <!-- Main -->
            <div class="summary-main">
              <div class="line-1">
                <strong class="name">{{ row.name || row.email }}</strong>
                <span class="email muted" *ngIf="row.name">{{ row.email }}</span>
                <span class="chip dco" *ngIf="row.dcoDisplay">{{ row.dcoDisplay }}</span>
              </div>
              <div class="line-2">
                <span class="chip stat"><i class="fa-duotone fa-user-clock"></i>{{ userAgg(row.userId).active }} active</span>
                <span class="chip stat"><i class="fa-duotone fa-layer-group"></i>{{ row.sessionsCount }} total</span>
                <span class="muted last-seen" *ngIf="row.lastSeenMax">• Last seen: {{ row.lastSeenMax | date:'short' }}</span>
              </div>
            </div>

            <!-- Right -->
            <div class="summary-right" *ngIf="userAgg(row.userId).browsers.length">
              <ng-container *ngFor="let b of userAgg(row.userId).browsers">
                <span class="browser-pill" [matTooltip]="b.label + ': ' + b.count">
                  <i [class]="browserIconClass(b.label)"></i>
                  <span class="count">{{ b.count }}</span>
                </span>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </td>

    </ng-container>

    <!-- groupDetail column -->
    <ng-container matColumnDef="groupDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="group-detail-cell">
        <ng-container *ngIf="row.kind === 'group' && expandedUserIds.has(row.userId)">
          <!-- Inner FLAT table for this user's sessions -->
          <table mat-table [dataSource]="userSessions(row.userId)" class="inner-table">
            <!-- reuse flat column defs here (duplicate ng-containers is fine) -->
            <!-- firstName -->
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let r">{{ r.firstName }}</td>
            </ng-container>
            <!-- lastName -->
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let r">{{ r.lastName }}</td>
            </ng-container>
            <!-- emailAddress -->
            <ng-container matColumnDef="emailAddress">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let r">{{ r.email }}</td>
            </ng-container>
            <!-- dco -->
            <ng-container matColumnDef="dco">
              <th mat-header-cell *matHeaderCellDef>DCO</th>
              <td mat-cell *matCellDef="let r">{{ r.dcoDisplay || '—' }}</td>
            </ng-container>
            <!-- authSource -->
            <ng-container matColumnDef="authSource">
              <th mat-header-cell *matHeaderCellDef>Auth</th>
              <td mat-cell *matCellDef="let r">
                <i class="fa-solid" [ngClass]="isInternal(r.authSource) ? 'fa-building internal-icon' : 'fa-globe external-icon'" style="margin-right: 6px;"></i>
                {{ isInternal(r.authSource) ? 'CareOregon Entra' : 'HealthTrio' }}
              </td>
            </ng-container>
            <!-- created -->
            <ng-container matColumnDef="created">
              <th mat-header-cell *matHeaderCellDef>Login</th>
              <td mat-cell *matCellDef="let r" [matTooltip]="r.createdUtc">{{ formatDt(r.createdUtc) }}</td>
            </ng-container>
            <!-- lastSeen -->
            <ng-container matColumnDef="lastSeen">
              <th mat-header-cell *matHeaderCellDef>Last seen</th>
              <td mat-cell *matCellDef="let r" [matTooltip]="r.lastSeenUtc || ''">{{ formatDt(r.lastSeenUtc) || '—' }}</td>
            </ng-container>
            <!-- browser -->
            <ng-container matColumnDef="browser">
              <th mat-header-cell *matHeaderCellDef>Browser</th>
              <td mat-cell *matCellDef="let r">
                <button type="button" mat-button class="ua-trigger" [matMenuTriggerFor]="uaDetailsGrouped"
                        (click)="hoveredRow = r; $event.stopPropagation()" aria-label="Show browser details">
                  <i [class]="browserIconClass(friendlyBrowser(r.chUa, r.userAgent))" class="ua-browser-icon"></i>
                  {{ friendlyBrowser(r.chUa, r.userAgent) }}
                </button>
              </td>
            </ng-container>
            <!-- isActive -->
            <ng-container matColumnDef="isActive">
              <th mat-header-cell *matHeaderCellDef class="centered-header">Active</th>
              <td mat-cell *matCellDef="let r" class="centered-cell">
                <span *ngIf="isInactive(r)" class="inactive-wrapper">
                  <i class="fa-solid fa-circle-xmark inactive-icon"
                     [title]="r.isTerminated ? 'Inactive (ended)' : 'Inactive (stale > ' + staleHours + 'h)'"></i>
                  <span *ngIf="isStale(r)" class="stale-asterisk" matTooltip="Last seen &gt; {{staleHours}} hours ago">*</span>
                </span>
                <i *ngIf="!isInactive(r)" class="fa-solid fa-circle-check active-icon" title="Active"></i>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let r; columns: displayedColumns" [ngClass]="{'stale-row': isStale(r)}"></tr>
          </table>
          <mat-menu #uaDetailsGrouped="matMenu" [overlapTrigger]="false" [hasBackdrop]="true" panelClass="ua-panel">
            <div class="ua-wrap" (click)="$event.stopPropagation()">
              <div class="ua-row">
                <span class="ua-label">Full Versions</span>
                <span class="ua-value monospace">{{ hoveredRow?.chUaFullVersion || '—' }}</span>
              </div>
              <div class="ua-row">
                <span class="ua-label">OS</span>
                <span class="ua-value">
                  <i [class]="osIconClass(hoveredRow?.chPlatform)" class="ua-os-icon"></i>
                  {{ friendlyOs(hoveredRow?.chPlatform, hoveredRow?.chPlatformVersion) }}
                </span>
              </div>
              <div class="ua-row">
                <span class="ua-label">Device</span>
                <span class="ua-value">
                  <i [class]="deviceIconClass(hoveredRow?.chMobile)" class="ua-device-icon"></i>
                  {{ deviceLabel(hoveredRow?.chMobile) }}
                </span>
              </div>
              <div class="ua-row" *ngIf="hoveredRow?.ipAddress">
                <span class="ua-label">IP</span>
                <span class="ua-value monospace">{{ hoveredRow?.ipAddress }}</span>
              </div>
              <div class="ua-row">
                <span class="ua-label">UA</span>
                <span class="ua-value monospace">
                  {{ (hoveredRow?.userAgent || '—') | slice:0:200 }}<ng-container *ngIf="hoveredRow?.userAgent?.length > 200">…</ng-container>
                </span>
              </div>
            </div>
          </mat-menu>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['groupSummary']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['groupSummary']; when: groupSummaryPredicate"></tr>
    <tr mat-row *matRowDef="let row; columns: ['groupDetail'];  when: groupSummaryPredicate"
        [class.collapse]="!expandedUserIds.has(row.userId)"></tr>
  </table>

  <!-- FLAT TABLE -->
  <table *ngIf="!groupByUser"
         mat-table
         [dataSource]="rows"
         class="mat-elevation-z1"
         matSort
         (matSortChange)="onSortChange($event)">

    <!-- Declare flat columns once, no *ngIf -->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
      <td mat-cell *matCellDef="let r">{{ r.firstName }}</td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
      <td mat-cell *matCellDef="let r">{{ r.lastName }}</td>
    </ng-container>
    <ng-container matColumnDef="emailAddress">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let r">{{ r.email }}</td>
    </ng-container>
    <ng-container matColumnDef="dco">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>DCO</th>
      <td mat-cell *matCellDef="let r">{{ r.dcoDisplay || '—' }}</td>
    </ng-container>
    <ng-container matColumnDef="authSource">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Auth</th>
      <td mat-cell *matCellDef="let r">
        <i class="fa-solid" [ngClass]="isInternal(r.authSource) ? 'fa-building internal-icon' : 'fa-globe external-icon'"
           style="margin-right: 6px;"></i>
        {{ isInternal(r.authSource) ? 'CareOregon Entra' : 'HealthTrio' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Login</th>
      <td mat-cell *matCellDef="let r" [matTooltip]="r.createdUtc">{{ formatDt(r.createdUtc) }}</td>
    </ng-container>
    <ng-container matColumnDef="lastSeen">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last seen</th>
      <td mat-cell *matCellDef="let r" [matTooltip]="r.lastSeenUtc || ''">{{ formatDt(r.lastSeenUtc) || '—' }}</td>
    </ng-container>
    <ng-container matColumnDef="browser">
      <th mat-header-cell *matHeaderCellDef>Browser</th>
      <td mat-cell *matCellDef="let r">
        <button type="button" mat-button class="ua-trigger" [matMenuTriggerFor]="uaDetailsFlat"
                (click)="$event.stopPropagation()">
          <i [class]="browserIconClass(friendlyBrowser(r.chUa, r.userAgent))" class="ua-browser-icon"></i>
          {{ friendlyBrowser(r.chUa, r.userAgent) }}
        </button>
        <mat-menu #uaDetailsFlat="matMenu" [overlapTrigger]="false" [hasBackdrop]="true" panelClass="ua-panel">
          <div class="ua-wrap" (click)="$event.stopPropagation()">
            <div class="ua-row">
              <span class="ua-label">Full Versions</span>
              <span class="ua-value monospace">{{ r.chUaFullVersion || '—' }}</span>
            </div>
            <div class="ua-row">
              <span class="ua-label">OS</span>
              <span class="ua-value">
                <i [class]="osIconClass(r.chPlatform)" class="ua-os-icon"></i>
                {{ friendlyOs(r.chPlatform, r.chPlatformVersion) }}
              </span>
            </div>
            <div class="ua-row">
              <span class="ua-label">Device</span>
              <span class="ua-value">
                <i [class]="deviceIconClass(r.chMobile)" class="ua-device-icon"></i>
                {{ deviceLabel(r.chMobile) }}
              </span>
            </div>
            <div class="ua-row" *ngIf="r.ipAddress">
              <span class="ua-label">IP</span>
              <span class="ua-value monospace">{{ r.ipAddress }}</span>
            </div>
            <div class="ua-row">
              <span class="ua-label">UA</span>
              <span class="ua-value monospace">
                {{ (r.userAgent || '—') | slice:0:200 }}<ng-container *ngIf="r.userAgent?.length > 200">…</ng-container>
              </span>
            </div>
          </div>
        </mat-menu>
      </td>

    </ng-container>
    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered-header">Active</th>
      <td mat-cell *matCellDef="let r" class="centered-cell">
        <span *ngIf="isInactive(r)" class="inactive-wrapper">
          <i class="fa-solid fa-circle-xmark inactive-icon"
             [title]="r.isTerminated ? 'Inactive (ended)' : 'Inactive (stale > ' + staleHours + 'h)'"></i>
          <span *ngIf="isStale(r)" class="stale-asterisk" matTooltip="Last seen &gt; {{staleHours}} hours ago">*</span>
        </span>
        <i *ngIf="!isInactive(r)" class="fa-solid fa-circle-check active-icon" title="Active"></i>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'stale-row': isStale(row)}"></tr>
  </table>




  <mat-paginator [length]="total"
                 [pageIndex]="pageIndex"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="[10,25,50,100]"
                 (page)="onPageChange($event)">
  </mat-paginator>
</div>
